import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import ConditionalWrapper from "../../Utility/ConditionalWrapper";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import { jsx as _jsx } from "react/jsx-runtime";
export var aspectRatios = ['horizontal', 'square', 'vertical'];
export var WebVideo = function WebVideo(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? '' : _ref$src,
    _ref$poster = _ref.poster,
    poster = _ref$poster === void 0 ? '' : _ref$poster,
    _ref$playerId = _ref.playerId,
    playerId = _ref$playerId === void 0 ? '' : _ref$playerId,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 'horizontal' : _ref$aspectRatio,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$autoPlayOnScroll = _ref.autoPlayOnScroll,
    autoPlayOnScroll = _ref$autoPlayOnScroll === void 0 ? false : _ref$autoPlayOnScroll,
    _ref$percentScrollToP = _ref.percentScrollToPlay,
    percentScrollToPlay = _ref$percentScrollToP === void 0 ? 0.05 : _ref$percentScrollToP,
    _ref$percentScrollToS = _ref.percentScrollToStop,
    percentScrollToStop = _ref$percentScrollToS === void 0 ? 0.85 : _ref$percentScrollToS,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? true : _ref$controls,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? false : _ref$loop,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    _ref$onPlay = _ref.onPlay,
    onPlay = _ref$onPlay === void 0 ? function () {} : _ref$onPlay,
    _ref$onPause = _ref.onPause,
    onPause = _ref$onPause === void 0 ? function () {} : _ref$onPause,
    _ref$onDuration = _ref.onDuration,
    onDuration = _ref$onDuration === void 0 ? function (duration) {} : _ref$onDuration,
    _ref$onProgress = _ref.onProgress,
    onProgress = _ref$onProgress === void 0 ? function (progress) {} : _ref$onProgress,
    _ref$onFinish = _ref.onFinish,
    onFinish = _ref$onFinish === void 0 ? function () {} : _ref$onFinish,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function (err) {} : _ref$onError,
    _ref$playOnVideoUpdat = _ref.playOnVideoUpdate,
    playOnVideoUpdate = _ref$playOnVideoUpdat === void 0 ? false : _ref$playOnVideoUpdat,
    _ref$playTitle = _ref.playTitle,
    playTitle = _ref$playTitle === void 0 ? 'Play Video' : _ref$playTitle,
    _ref$pauseTitle = _ref.pauseTitle,
    pauseTitle = _ref$pauseTitle === void 0 ? 'Pause Video' : _ref$pauseTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFinished = _useState4[0],
    setIsFinished = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    progress = _useState6[0],
    setProgress = _useState6[1];
  var getCurrentTimeMs = function getCurrentTimeMs(jsPlayer) {
    var currentTime = jsPlayer.currentTime();
    return currentTime !== undefined ? Math.round(currentTime * 1000) : 0;
  };
  var videoRef = useRef(null);
  var playerRef = useRef(null);
  var isAutoPlaying = useRef(false);
  var playerOnPause = useRef(false);
  var volumeChanged = useRef(false);
  var forceRecalculate = useRef(function () {});
  var getPlayers = function getPlayers() {
    var players = [];

    // Use videojs.getPlayers() to get all players
    var playerObjects = videojs.getPlayers();

    // Convert the PlayerObjectMap to an array
    for (var _playerId in playerObjects) {
      if (playerObjects.hasOwnProperty(_playerId)) {
        players.push(playerObjects[_playerId]);
      }
    }
    return players;
  };
  var getOtherPlayers = useCallback(function () {
    if (typeof window === 'undefined' || !playerRef.current) {
      return [];
    }
    var currentPlayerId = playerRef.current.id();
    var allPlayers = getPlayers();
    var otherPlayers = Object.values(allPlayers).filter(function (bcPlayer) {
      return bcPlayer && bcPlayer.id() !== currentPlayerId;
    });
    return otherPlayers;
  }, []);
  var pauseOtherPlayers = useCallback(function () {
    getOtherPlayers().forEach(function (jsPlayer) {
      if (jsPlayer.readyState() > 2) {
        jsPlayer.pause();
      }
    });
  }, [getOtherPlayers]);
  var isOtherPlayersFullscreen = function isOtherPlayersFullscreen() {
    return getOtherPlayers().some(function (playerRef) {
      return playerRef.isFullscreen();
    });
  };
  var isCurrentPlayerFullscreen = function isCurrentPlayerFullscreen() {
    return playerRef.current && playerRef.current.isFullscreen();
  };
  var updatePlayButtons = function updatePlayButtons(title) {
    if (playerRef.current) {
      // Big play button 'title' attribute and <span> text.
      var bigPlayButton = playerRef.current.bigPlayButton.el();
      if (bigPlayButton) {
        bigPlayButton.title = title;
        if (bigPlayButton.firstChild && bigPlayButton.firstChild instanceof HTMLElement) {
          bigPlayButton.firstChild.innerHTML = title;
        }
      }

      // Control bar play button 'title' attribute and <span> text.
      var controlBar = playerRef.current.getChild('controlBar');
      if (controlBar && controlBar.firstChild && controlBar.firstChild instanceof HTMLElement) {
        controlBar.firstChild.title = title;
        if (controlBar.firstChild.firstChild && controlBar.firstChild.firstChild instanceof HTMLElement) {
          controlBar.firstChild.firstChild.innerHTML = title;
        }
      }
    }
  };
  var onPlayerPlay = useCallback(function () {
    updatePlayButtons(pauseTitle);
    pauseOtherPlayers();
    setIsPlaying(true);
    if (playerRef.current) {
      setProgress(getCurrentTimeMs(playerRef.current));
    }
    setIsFinished(false);
  }, [pauseTitle, pauseOtherPlayers]);
  var onPlayerPause = useCallback(function () {
    updatePlayButtons(playTitle);
    setIsPlaying(false);
    if (playerRef.current) {
      setProgress(getCurrentTimeMs(playerRef.current));
    }
  }, [playTitle]);
  var onScrollToVideo = function onScrollToVideo(percentValue, percentScroll) {
    var player = playerRef.current;

    // Do not do anything if user has clicked pause video.
    if (playerOnPause.current || !player) {
      return;
    }
    if (!isPlaying && percentScroll >= percentScrollToPlay && percentScroll <= percentScrollToStop) {
      // Special case: on switch to full screen
      // neighbour video should not start autoplaying.
      if (isOtherPlayersFullscreen()) {
        return;
      }

      // Play video and pause other players.
      player.muted(true);
      player.play();
      isAutoPlaying.current = true;
    } else if (isPlaying && (percentScroll < percentScrollToPlay || percentScroll > percentScrollToStop)) {
      // Special case: on switch to full screen
      // no need to pause().
      if (isCurrentPlayerFullscreen()) {
        return;
      }
      player.pause();
      isAutoPlaying.current = false;
      volumeChanged.current = false;
    }
  };
  useEffect(function () {
    if (isPlaying) {
      onPlay();
    } else {
      onPause();
    }
  }, [onPlay, onPause, isPlaying]);
  useEffect(function () {
    isAutoPlaying.current = false;
    volumeChanged.current = false;
    playerOnPause.current = false;
    if (!autoPlayOnScroll) {
      forceRecalculate.current = function () {};
    }
    setIsPlaying(false);
    setIsFinished(false);
    setProgress(0);
  }, [autoPlayOnScroll]);

  // Initialize the JSPlayer
  useEffect(function () {
    if (!playerRef.current) {
      var _videoRef$current;
      var videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.appendChild(videoElement);
      var options = {
        controls: controls,
        responsive: true,
        sources: [{
          src: src,
          type: 'video/mp4'
        }],
        poster: poster
      };
      var player = playerRef.current = videojs(videoElement, options, function () {
        videojs.log('player is ready');
        player.on('play', onPlayerPlay);
        player.on('pause', onPlayerPause);
      });
    }
  }, [src, autoplay, controls, onPlayerPause, onPlayerPlay, poster]);

  // Dispose the player when the component is unmounted
  useEffect(function () {
    var player = playerRef.current;
    return function () {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, []);
  useEffect(function () {
    onProgress(progress);
  }, [onProgress, progress]);
  useEffect(function () {
    if (isPlaying) {
      onPlay();
    } else {
      onPause();
    }
  }, [onPlay, onPause, isPlaying]);
  useEffect(function () {
    if (isFinished) {
      onFinish();
    }
  }, [onFinish, isFinished]);
  useEffect(function () {
    if (playerRef.current) {
      var player = playerRef.current;

      // Set the video source
      player.src({
        src: src,
        type: 'video/mp4'
      });
      player.poster(poster);

      // Autoplay logic (if applicable)
      if (!autoPlayOnScroll && playOnVideoUpdate) {
        if (player.contentEl().offsetParent !== null) {
          player.play();
        }
      }

      // Optionally, you can reset the player state here
      // if you want to ensure a fresh start when the src changes
      player.pause();
    }
  }, [src, poster, playOnVideoUpdate, autoPlayOnScroll]);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: autoPlayOnScroll,
    wrapper: function wrapper(_children) {
      return /*#__PURE__*/_jsx(ScrollTransform, {
        onChange: onScrollToVideo,
        startScrollPercent: 0,
        endScrollPercent: 1,
        transforms: [],
        disableCalculateOnMount: true,
        children: function children(forceScrollRecalculate) {
          forceRecalculate.current = forceScrollRecalculate;
          return _children;
        }
      });
    },
    children: /*#__PURE__*/_jsx("div", {
      className: classnames(!controls ? 'hide-controls' : undefined, aspectRatio),
      "data-e2e-name": "ww_video",
      "data-vjs-player": true,
      children: /*#__PURE__*/_jsx("div", {
        ref: videoRef
      })
    })
  });
};